import { EOnboaringFormStep } from '@constants';
import { useCallback, useEffect } from 'react';

import { useSignWellScript } from '../../../../../hooks/useSignWellScript';

import { ContractWrapper, FormWrapper } from './Contract.styles';

import { useOnboardingFormLogic } from '@/hooks';
import { useUserOnboarding, useMutateUserContract, useProfile } from '@/store';

export const Contract: React.FC = () => {
  const { startLoadingAfterContract, currentStep } = useOnboardingFormLogic();
  const { isScriptLoaded, openSignWell, closeSignWell } = useSignWellScript();
  const { generateUserContract } = useMutateUserContract();
  const { profile } = useProfile();
  const { userOnboarding, refetch } = useUserOnboarding();

  const handleSetIsContractSigned = useCallback(() => {
    startLoadingAfterContract();
    closeSignWell();
  }, []);

  useEffect(() => {
    refetch();
  }, [currentStep]);

  useEffect(() => {
    if (!isScriptLoaded || !profile || currentStep !== EOnboaringFormStep.FINAL_STEP) {
      return;
    }

    if (!userOnboarding?.contract?.isContractSigned && !userOnboarding?.contract?.signUrl) {
      generateUserContract();
      return;
    }

    const isSigned = userOnboarding?.contract?.isContractSigned;
    const hasSignUrl = !!userOnboarding?.contract?.signUrl;
    const hasContractFile = !!userOnboarding?.contract?.contractFile;

    const isPendingSignature = !isSigned && hasSignUrl && !hasContractFile;
    const isSignedButWithoutContractFile = isSigned && hasSignUrl && !hasContractFile;
    const existsContractFileButNotSigned = !isSigned && hasSignUrl && hasContractFile;

    const shouldOpenSignWell =
      isPendingSignature || isSignedButWithoutContractFile || existsContractFileButNotSigned;

    if (shouldOpenSignWell) {
      openSignWell(userOnboarding?.contract?.signUrl || '', {
        onComplete: handleSetIsContractSigned,
        onClose: handleSetIsContractSigned
      });
    } else {
      const isContractCompleted = isSigned && hasContractFile && hasSignUrl;
      if (isContractCompleted) {
        handleSetIsContractSigned();
      }
    }
  }, [
    currentStep,
    userOnboarding?.contract?.signUrl,
    userOnboarding?.contract?.isContractSigned,
    userOnboarding?.contract?.contractFile,
    isScriptLoaded,
    profile
  ]);

  if (!profile || !profile.legalId || !profile.birthday) {
    return null;
  }

  return (
    <FormWrapper>
      <ContractWrapper id="contract-wrapper" />
    </FormWrapper>
  );
};
